import React from 'react'
import PropTypes from 'prop-types'
import Moment from 'moment-timezone'

import { formatDate, parseMoment } from 'commons/js/util/dateConverter'
import {
    TIMESTAMP_FORMAT,
    DATE_FORMAT,
    DATETIME_FORMAT,
    DATETIME_FORMAT_WITH_SECONDS,
    DATETIME_FORMAT_WITH_MILLISECONDS,
    TIMEZONE_FORMAT,
    TIMEZONE_FORMAT_ABBR,
} from 'commons/js/constants'

const PARSE_FORMATS = [
    TIMESTAMP_FORMAT,
    DATE_FORMAT,
    DATETIME_FORMAT,
]

const DateTime = ({ value, format, timeZone, utcOffset }) => {
    const date = parseMoment(value, PARSE_FORMATS)

    if (timeZone) {
        date.tz(timeZone)
    }

    if (utcOffset) {
        date.utcOffset(utcOffset)
    }

    if (format === TIMEZONE_FORMAT && !TIMEZONE_FORMAT_ABBR) {
        return date.tz()
    }

    return (
        <time dateTime={formatDate(date, DATETIME_FORMAT_WITH_MILLISECONDS)}>
            {formatDate(date, format)}
        </time>
    )
}

DateTime.propTypes = {
    value: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.string,
        PropTypes.instanceOf(Date),
        PropTypes.instanceOf(Moment),
    ]).isRequired,
    format: PropTypes.string,
    timeZone: PropTypes.string,
    utcOffset: PropTypes.string,
}

DateTime.defaultProps = {
    format: DATETIME_FORMAT_WITH_SECONDS,
}

export default DateTime
